module.exports = __webpack_public_path__ + "media/images/image_sonaeru-365acdfc.jpeg";